const WHO_IS_LISTENING_PATH = '/identity/who-is-listening'

/**
 * The profile picker, carrying a relative `returnTo` built from the current
 * path (never read back from the URL's own query) so the picker can send the
 * customer back. Omitted for a bare home page and anywhere under `/identity/`,
 * which would bounce the customer between profile pages.
 */
export function profilePickerUrl(location: Pick<Location, 'pathname' | 'search'>): string {
    const { pathname, search } = location
    if ((pathname === '/' && !search) || pathname.startsWith('/identity/')) {
        return WHO_IS_LISTENING_PATH
    }
    return `${WHO_IS_LISTENING_PATH}?returnTo=${encodeURIComponent(pathname + search)}`
}
